<template>
    <main-content>
        <kt-panel>
            <div class="accordion accordion-toggle-arrow" id="userFilter">
                <div class="card" style="overflow:inherit">
                    <div class="card-header bg-transparent" id="headingOne">
                        <div class="card-title collapsed" data-toggle="collapse"
                             data-target="#filterForm"
                             aria-controls="filterForm">
                            {{ $t('label.search') }}
                        </div>
                    </div>
                    <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                        <div class="card-body">
                            <form @submit.prevent="action($event, query)">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col md="4">
                                            <kt-form-group>
                                                <kt-form-label for="shareholder_name">
                                                    {{ $t('label.shareholder_name') }}
                                                </kt-form-label>
                                                <kt-form-control ref="shareholder_name" dir="rtl" name="shareholder_name" id="shareholder_name" v-model="query.shareholder_name" />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col md="4">
                                            <kt-form-group>
                                                <kt-form-label for="user_name">
                                                    {{ $t('label.User_full_name') }}
                                                </kt-form-label>
                                                <kt-form-control ref="user_name" dir="rtl" name="user_name" id="user_name" v-model="query.user_name" />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col md="4">
                                            <kt-form-group>
                                                <kt-form-label for="level">
                                                    {{ $t('label.level') }}
                                                </kt-form-label>
                                                <select id="levels"
                                                        ref="levels"
                                                        name="levels"
                                                        class="form-control kt-selectpicker"
                                                        v-model="query.level">
                                                    <option value=""></option>
                                                    <option v-for="level in levels" :key="level.id" :value="level.id">
                                                        {{ level.name }}
                                                    </option>
                                                </select>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>

                                <kt-form-section>
                                    <kt-row>
                                        <kt-col md="4">
                                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </kt-panel>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </main-content>
</template>

<script>
import {StarShopApiUrl, walletService} from "../../common/api.service";
import {AuthorizationHeader} from "../../common/jwt.service";
import MainContent from "../../components/main-content.vue";
import shareholderColumns from "./datatable/shareholderColumns";

export default {
    name: "GetShareholders",
    components: {MainContent},
    data() {
        return {
            query: {},
            levels: []
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "stakeholders_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: StarShopApiUrl.path('admin/shareholders'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data;
                            },
                            params: this.query
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: shareholderColumns,
            }
        },
    },
    methods: {
        action(e, query) {
            this.query = query;

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },
    },
    async mounted() {
        await walletService.getLevels()
            .then(res => {
                this.levels = res.data.data.general_levels;
            })
    }
}
</script>

<style scoped>

</style>